<div class="flex flex-col min-h-[60vh]">
	<app-index-insert #indexInsert class="flex-1"></app-index-insert>
	<div class="flex justify-between pt-6 mt-4">
		<p-button [label]="translateServ.dictionary['BACK']"
			[icon]="dirServ.isRtl() ? 'pi pi-arrow-right' : 'pi pi-arrow-left'"
			[iconPos]="dirServ.isRtl() ? 'right' : 'left'" severity="secondary" (onClick)="prevStep.emit()">
		</p-button>
		<p-button [label]="translateServ.dictionary['NEXT']"
			[icon]="dirServ.isRtl() ? 'pi pi-arrow-left' : 'pi pi-arrow-right'"
			[iconPos]="dirServ.isRtl() ? 'left' : 'right'" (onClick)="nextStep.emit()" [disabled]="!canGoNextDialog">
		</p-button>
	</div>
</div>